import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import ReactGA from "react-ga4";
import { AuthProvider } from "@@contexts/AuthContext";
import AppRouter from "@@setup/AppRouter";
import BaseConfiguration from "@@setup/BaseConfiguration";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

const App: React.FC = () => {
  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS || "", {
      gaOptions: {}, //TODO: add metrics if necessary
    });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <BaseConfiguration>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BaseConfiguration>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App;
